module.exports = __webpack_public_path__ + "media/home.05f5185c.mp4";